<template>
  <div class="footer-wrap flex-box">
    <div class="left flex-1"></div>
    <div class="footer-box flex-box">
      <div class="left-content flex-box align-start">
        <div class="arrow"></div>

        <div class="address-box">
          <!-- <img src="../assets/footer-logo.png" class="logo" /> -->
          <p class="desc">{{$t('数据来源：中国医学科学院基础医学研究所')}}</p>
          <ul class="contact-box">
            <li class="item flex-box">
              <span>{{$t('联系人: 赵秀丽')}}</span>
            </li>
            <li class="item flex-box">
              <span>{{$t('电话')}}</span>
            </li>
            <li class="item flex-box">
              <span>{{$t('邮箱：xiulizhao@ibms.pumc.edu.cn')}}</span>
            </li>
            <li class="item flex-box">
              <span>{{$t('地址：北京市东单三条5号')}}</span>
            </li>
            <li class="item flex-box">
              <span>{{$t('技术支持：国家人口健康科学数据中心')}}</span>
            </li>
            <li class="item flex-box">
              <span>{{$t('电话：010-65250541（工作日8:30-17:00）')}}</span>
            </li>
            <li class="item flex-box">
              <span>{{$t('邮箱：rkjkpt@126.com')}}</span>
            </li>
          </ul>
          <ul class="concat-box2 flex-box" v-if='false'>
            <li class="item">
              <img src="../assets/wechact.png" class="image" alt="">
            </li>
            <li class="item">
              <img src="../assets/qq.png" class="image" alt="">
            </li>
            <li class="item">
              <img src="../assets/douyin.png" class="image" alt="">
            </li>
            <li class="item">
              <img src="../assets/weibo.png" class="image" alt="">
            </li>
          </ul>
        </div>
      </div>
      
      <div class="right-content flex-1">
        <div class="fix-box">
          <div class="flex-box">
            <img src="../assets/footer/logo1.png" class="logo1" alt="">
            <div class="right-text">
              <p class="text1">{{$t('医学研究所')}}</p>
              <p class="text2">{{$t('基础学院')}}</p>
            </div>
          </div>
          <div class="flex-box logo-box">
            <div class="nsti-box"></div>
            <img src="../assets/footer/logo3.png" class="logo3" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="right flex-1"></div>
  </div>
</template>

<script>
export default {
  name: '',

  data () {
    return {
    }
  },

  methods: {}
}
</script>

<style lang='scss' scoped>
.footer-wrap {
  height: 315px;
  width: 100%;
  .left {
    height: 100%;
    background: #304870;
  }
  .right {
    height: 100%;
    background: #4EABF9;
  }
  .logo-box {
    margin-top: 12px;
  }
  .nsti-box {
    height: 38px;
    width: 79px;
    background: url('../assets/footer/logo4.png');
    background-size: 100% 100%;
    margin-right: 12px;
  }
  .footer-box {
    min-width: 1280px;
    max-width: 1440px;
    height: 100%;
    .left-content {
      background: #304870;
      position: relative;
      width: 1130px;
      height: 100%;
      overflow: hidden;
      padding-top: 28px;
      box-sizing: border-box;
      .arrow {
        border: 315px solid transparent;
        border-top-color: #4EABF9;
        position: absolute;
        top: 0;
        right: -315px;
      }
      .address-box {
        // width: 280px;
        padding-top: 12px;
        color: #fff;
        font-size: 14px;
        .logo {
          widows: 250px;
          height: 35px;
        }
        .desc {
          margin-top: 4px;
        }
        .contact-box {
          margin-top: 8px;
          .item {
            margin-bottom: 2px;
          }
          .image {
            width: 32px;
            height: 32px;
            margin-right: 8px;
          }
        }
        .concat-box2 {
          margin-top: 30px;
          .item {
            margin-right: 12px;
            .image {
              width: 26px;
              height: 26px;
            }
          }
        }
      }
      .statement-box {
        margin-left: 62px;
        padding-top: 40px;
        width: 349px;
        color: #fff;
        .title {
          font-size: 16px;
          font-weight: bolder;
        }
        .desc {
          font-size: 12px;
          margin-top: 16px;
        }
      }
    }
    .fix-box {
        position: absolute;
        left: -390px;
        top: 40px;
        width: 476px;
        background: rgba($color: #000000, $alpha: 0.4);
        box-sizing: border-box;
        padding: 16px;
        color: #fff;
        .logo1 {
          border-radius: 50%;
          height: 60px;
          width: 60px;
          margin-right: 8px;
        }
        .logo2, .logo3 {
          height: 30px;
          margin-top: 10px;
        }
        .title2 {
          font-size: 17px;
          margin-top: 3px;
          margin-bottom: 17px;
        }
        .desc {
          font-size: 12px;
          background: #4EABF9;
          padding: 4px 4px;
          display: inline-block;
          margin-bottom: 6px;
        }
      }
    .right-content {
      background: #4EABF9;
      height: 100%;
      position: relative;
    }
  }
}
</style>
